/** Every condition a rule needs: the first, then each `and` clause. */
export function ruleConditions(rule) {
    return [rule.condition, ...(rule.and ?? [])];
}
//# sourceMappingURL=rule-conditions.js.map